import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class CommissionerContainer extends ShadowDOMElement {
	static className = "CommissionerContainer";
	
	static get properties() {
		return {
			required: { type: Boolean }
		};
	}
	
	// Property to indicate if at least one commissioner is required
	// By default false (commissioners are optional)
	required = false;
	
	render() {
    return html`
      <title-field label="Commissaires aux Comptes"></title-field>
      <checkbox-field
        label="Commissaire aux Comptes titulaire"
		id="chk-titulaire-container"
        @change="${this.toggleVisibility.bind(this, 'titulaire-container')}"
      ></checkbox-field>
      <personne-container
        id="titulaire-container"
		name="titulaire-container"
        visible="false"
		representative="true"></personne-container>
      <checkbox-field
        label="Commissaire aux Comptes suppléant"
		id="chk-suppleant-container"
        @change="${this.toggleVisibility.bind(this, 'suppleant-container')}"
      ></checkbox-field>
      <personne-container
        id="suppleant-container"
		name="suppleant-container"
        visible="false"
		exercises="true"
		representative="true"></personne-container>
    `;
	}

	toggleVisibility (containerId, event){
		const container = this.shadowRoot.querySelector(`#${containerId}`);
		if (container)
			container.visible = event.target.checked;

		// If the checkbox is checked, remove all existing validation messages
		if (event.target.checked) {
			this.shadowRoot.querySelectorAll('div[data-validation-for]').forEach(el => el.remove());
		}
	}
	
	// Validation: show messages for each checkbox if none checked; return false in that case.
	validate() {
		// If 'required' property is false, no validation needed (commissioners are optional)
		if (!this.required) {
			return true;
		}
		
		const checkboxes = this.shadowRoot.querySelectorAll('checkbox-field');

		// remove all existing validation messages first
		this.shadowRoot.querySelectorAll('div[data-validation-for]').forEach(el => el.remove());

		// if any checkbox is checked -> valid
		const anyChecked = Array.from(checkboxes).some(cb => !!cb.checked);
		if (anyChecked) {
			return true;
		}

		// none checked: show message for each checkbox and return false
		checkboxes.forEach(cb => {
			const id = cb.id || cb.getAttribute('id') || '';

			const row = document.createElement('div');
			row.className = 'row align-items-center';
			row.setAttribute('data-validation-for', id);

			const colLeft = document.createElement('div');
			colLeft.className = 'col-sm-3';

			const colRight = document.createElement('div');
			colRight.className = 'col-sm-9 text-danger d-flex align-items-center';
			colRight.style.paddingBottom = '0.25rem';
			colRight.style.paddingLeft = '0px';

			const icon = document.createElement('i');
			icon.className = 'fa-solid fa-circle-exclamation me-2';
			icon.setAttribute('aria-hidden', 'true');

			const text = document.createElement('span');
			text.textContent = 'Vous devez cocher au moins une modification';

			colRight.appendChild(icon);
			colRight.appendChild(text);

			row.appendChild(colLeft);
			row.appendChild(colRight);

			if (cb.parentNode) cb.parentNode.insertBefore(row, cb.nextSibling);
		});

		return false;
	}

	isTransient (){
		return false;
	}

	#updateContainers (){
		const container1Visible = this.shadowRoot.querySelector("#chk-titulaire-container").checked;
		const container2Visible = this.shadowRoot.querySelector("#chk-suppleant-container").checked;
		
		this.shadowRoot.querySelector("#titulaire-container").visible = container1Visible;
		this.shadowRoot.querySelector("#suppleant-container").visible = container2Visible;
	}

	setValues (values){
		super.setValues (values);
		this.#updateContainers ();
		this.requestUpdate ();
	}
}

customElements.define("commissioner-container", CommissionerContainer);
